<template>
    <section class="h-100">
        <front-table :front_page="page"
                     :front_records="records"
                     :front_search="search"
                     :front_header="header"
                     :model="model"
                     @reload="handleReload"
                     :btn_edit="true"
                     :btn_add="false"
                     :btn_delete="false"
                     btn_review
                     @edit="handleEdit"
                     @review="handleMeetingReview"
        >
        </front-table>
        <el-dialog :title="(meeting.id?'('+meeting.id+')':'')+meeting.topic + ' <' + meeting.approve + '>' "
                   :visible.sync="view_mode"
                   width="85%"
                   :close-on-click-modal="false">

            <el-row :gutter="20">
                <el-col :span="12">
                    <div class="d-flex">
                        <div class="page-label">会议id:</div>
                        <div class="page-content">{{ meeting.meeting_id ? meeting.meeting_id : '待创建' }}</div>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div class="d-flex">
                        <div class="page-label">会议时间:</div>
                        <div class="page-content">{{ meeting.meeting_date }} {{ meeting.meeting_time }}
                            ({{ meeting.duration }})
                        </div>
                    </div>
                </el-col>
            </el-row>

            <el-row :gutter="20">
                <el-col :span="12">
                    <div class="d-flex">
                        <div class="page-label">参会链接:</div>
                        <div class="page-content">{{ meeting.join_url }}</div>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div class="d-flex">
                        <div class="page-label">密码:</div>
                        <div class="page-content"><b>{{ meeting.password ? meeting.password : '无' }}</b> <span
                            v-if="meeting.zcode"
                            class="text-danger"> | 主持密码:{{ meeting.zcode }}</span>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <div class="d-flex">
                        <div class="page-label">主持人:</div>
                        <div class="page-content">{{ meeting.host_id }}({{ meeting.host_name }}) <span
                            class="text-success" v-if="meeting.assistant_name"> | {{ meeting.assistant_name }}</span>
                        </div>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div class="d-flex">
                        <div class="page-label">会议室:</div>
                        <div class="page-content">{{ meeting.room_name_group }}</div>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="20" v-if="meeting.platform_code == 1">
                <el-col :span="24">
                    <div class="d-flex">
                        <div class="page-label">主持密码:</div>
                        <div class="page-content d-flex " >
                            <el-button size="mini" @click="makeRandomPassword" class="mr-2"
                                       icon="el-icon-magic-stick">生成
                            </el-button>
                            <el-input v-model="zcode"  size="mini"
                                      placeholder="6位纯数字"></el-input>
                            <el-button  type="danger" size="mini" @click="changeHostPassword" class="ml-2"
                                       icon="el-icon-edit">修改主持密码
                            </el-button>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-table
                        class="bg-light"
                        size="mini"
                        :data="meeting.participants?meeting.participants.filter(data => !search_user || data.name.toLowerCase().includes(search_user.toLowerCase())):[]"
                        stripe
                        style="width: 100%">
                        <el-table-column prop="name">
                            <div slot="header" class="d-flex" slot-scope="scope">
                                <el-input style="flex:1 1 5em; margin-right: 5px;" v-model="search_user" size="mini"
                                          v-if="scope" clearable
                                          placeholder="搜索用户"/>
                            </div>
                            <template slot-scope="scope">
                                <span :class="{'text-danger':(scope.row.user_role > 1)}">{{ scope.row.name }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="user_role" label="级别"></el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <el-button v-if="scope.row.user_role < 2" @click="coHost(scope.row)" type="text"
                                           size="small" icon="el-icon-arrow-right">设为联席主持人
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <div class="pull-left">
                    <el-button type="danger" size="small" @click="handleLock" icon="el-icon-lock"> 关闭会议</el-button>
                    <el-button type="success" size="small" @click="handleUnlock" icon="el-icon-unlock">开启会议</el-button>
                    <el-button type="primary" size="small" @click="handleResentCreationNotice" icon="el-icon-postcard">
                        重发建会通知邮件
                    </el-button>
                </div>
                <el-button type="info" @click="view_mode=false" icon="el-icon-close">关 闭</el-button>
            </div>
        </el-dialog>

        <div class="clearfix"></div>
    </section>
</template>

<script>
import FrontTable from "../components/front-table";
import FrontMixins from "../common/mixins/front-mixins";
import AdminLockMixins from "@/views/mixins/admin-lock-mixins";

export default {
    mixins: [FrontMixins, AdminLockMixins],
    name: 'meeting-lock',
    components: {FrontTable},
}
</script>

<style lang="scss">
.page-label {
    flex: 0 0 80px;
    width: 80px;
    text-align: left;
    font-weight: bold;
    display: inline-block;
    line-height: 30px;
    background-color: aliceblue;
    padding: 0 5px;
}

.page-content {
    flex: 1;
    text-align: left;
    margin-left: 10px;
    display: inline-block;
    line-height: 30px;
    border-bottom: solid 1px #b2ebf2;
    overflow: auto;
}

</style>
